import React from "react"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import classes from "./CdsCheckoutSummary.module.scss"

const CdsCheckoutSummary = (props) => {
  const {
    total,
    subtotal,
    taxesAndCharges,
    totalFoodDiscounts,
    totalDeliveryDiscountByCoupon,
    totalDeliveryFeeBeforeDiscount
  } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <div className={classes["total-item"]}>
        <div>
          {t("مجموع_اقلام")}
        </div>

        <div className={classes["number"]}>
          {thousandSeparator(subtotal)}
        </div>
      </div>

      {taxesAndCharges.map(tax =>
        <div
          key={tax.title}
          className={classes["total-item"]}
        >
          <div className={classes["title"]}>
            {tax.title}{" "}
            {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>

          <div className={classes["number"]}>
            {thousandSeparator(tax.amount)}
          </div>
        </div>
      )}

      {
        totalDeliveryFeeBeforeDiscount !== 0 &&
        <div className={classes["total-item"]}>
          <div>{t("هزینه_ی_ارسال")}</div>
          <div className={classes["number"]}>
            {thousandSeparator(totalDeliveryFeeBeforeDiscount)}
          </div>
        </div>
      }

      {
        totalFoodDiscounts > 0 &&
        <div className={classes["total-item"]}>
          <div className={classes["title"]}>
            {t("تخفیف")}
          </div>

          <div className={classes["number"]}>
            {thousandSeparator(-totalFoodDiscounts)}
          </div>
        </div>
      }

      {
        totalDeliveryDiscountByCoupon > 0 &&
        <div className={classes["total-item"]}>
          <div className={classes["title"]}>
            {t("تخفیف_ارسال")}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalDeliveryDiscountByCoupon)}
          </div>
        </div>
      }

      <div className={classes["total-container"]}>
        <div className={classes["total-text"]}>
          {t("جمع_نهایی")}
        </div>

        <div className={classes["total"]}>
          {thousandSeparator(total)}
        </div>
      </div>
    </div>
  )
}

export default CdsCheckoutSummary